// extracted by mini-css-extract-plugin
module.exports = {"root":"RegistrationSuccess_root__emKhU","header":"RegistrationSuccess_header__1Vz8A","text":"RegistrationSuccess_text__2bWUb"};